import { AnketaResourcesEnum } from "./resources";

/**
 * The opsanio UI features - one per section in the opsanio side nav. Each maps to
 * its own ABAC resource (`opsanio/updates`, `opsanio/contact`,
 * `opsanio/appliance`, `opsanio/documentation`, `opsanio/hardware`) with the
 * delegated actions view/create/update/delete (`hardware` is read-only: `view`),
 * managed in the editable matrix (Admin => Berechtigungen). Access is layered: a
 * user must pass the coarse "Opsanio gate" (membership in an internal org:
 * `isMedocino` or `isAutonubil`) AND hold the matrix permission for that
 * feature resource + action.
 */
export enum OpsanioFeatureEnum {
  updates = "updates",
  contact = "contact",
  appliance = "appliance",
  documentation = "documentation",
  hardware = "hardware",
}

export const ALL_OPSANIO_FEATURES: OpsanioFeatureEnum[] = [
  OpsanioFeatureEnum.updates,
  OpsanioFeatureEnum.contact,
  OpsanioFeatureEnum.appliance,
  OpsanioFeatureEnum.documentation,
  OpsanioFeatureEnum.hardware,
];

/** The ABAC resource backing an opsanio feature. */
export const OPSANIO_FEATURE_RESOURCE: Record<
  OpsanioFeatureEnum,
  AnketaResourcesEnum
> = {
  [OpsanioFeatureEnum.updates]: AnketaResourcesEnum.opsanioUpdates,
  [OpsanioFeatureEnum.contact]: AnketaResourcesEnum.opsanioContact,
  [OpsanioFeatureEnum.appliance]: AnketaResourcesEnum.opsanioAppliance,
  [OpsanioFeatureEnum.documentation]: AnketaResourcesEnum.opsanioDocumentation,
  [OpsanioFeatureEnum.hardware]: AnketaResourcesEnum.opsanioHardware,
};

export const opsanioFeatureResource = (
  feature: OpsanioFeatureEnum
): AnketaResourcesEnum => OPSANIO_FEATURE_RESOURCE[feature];
